import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { LARGE_LOGO_WIDTH } from '../TeamStats/styles';

export const GoaltenderStatsContainer = styled.div<{ $isStatsOnly?: boolean }>`
    align-items: center;
    display: flex;
    height: ${({ $isStatsOnly }) => ($isStatsOnly ? '48px' : '64px')};
    padding: 0 8px;
    justify-content: start;

    ${BaseStyle.Mixins.screenSizes.medium} {
        justify-content: center;
    }
`;

export const GoaltenderContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    align-items: center;
    display: flex;
    justify-content: start;

    ${BaseStyle.Mixins.screenSizes.medium} {
        min-width: ${LARGE_LOGO_WIDTH}px;
    }
`;

export const GoaltenderIdentifiers = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    top: 3px;
`;

export const FirstName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    text-overflow: ellipsis;
    padding-bottom: 2px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['14m']}
    }
`;

export const LastName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    text-overflow: ellipsis;
    padding-bottom: 4px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['18b']}
    }
`;

export const SweaterNumber = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    color: ${({ theme }) => theme.Text.secondary};
`;
